import { render, staticRenderFns } from "./TranMemberListDialog.vue?vue&type=template&id=35383f2c&"
import script from "./TranMemberListDialog.vue?vue&type=script&lang=js&"
export * from "./TranMemberListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSeparator,QSelect,QInput,QIcon,QBtn,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSeparator,QSelect,QInput,QIcon,QBtn,QBadge,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
